module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showOver) ? _c('gameOver', {
    attrs: {
      "gameData": _vm.postGameData,
      "showNextButton": _vm.showNextButton,
      "score": _vm.gameScore,
      "gameFlag": _vm.gameFlag,
      "forbid": _vm.timeToForbid
    },
    on: {
      "restart": _vm.restartTrain,
      "close": _vm.closeGame,
      "next": _vm.nextGame
    }
  }) : _vm._e(), _vm._v(" "), (_vm.saveGame) ? _c('trainCronSave', {
    attrs: {
      "rest": _vm.rest,
      "gameData": _vm.gameData,
      "gameFlag": _vm.gameFlag,
      "caseId": _vm.caseId,
      "todayGames": _vm.imgList
    },
    on: {
      "update:rest": function($event) {
        _vm.rest = $event
      },
      "restart": _vm.restartLanTrain,
      "updateScore": _vm.getGameScore,
      "close": function($event) {
        _vm.saveGame = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "demo-grid"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('span', {
    staticClass: "train-title"
  }, [_vm._v("现场训练")])])], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_vm._l((_vm.imgList), function(item) {
    return (_vm.showContent) ? _c('div', {
      staticClass: "game-style"
    }, [_c('div', {
      staticClass: "pointer spanimg",
      on: {
        "click": function($event) {
          _vm.openGame(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.address + item.image,
        "width": "200px",
        "height": "200px"
      }
    }), _vm._v(" "), (item.counts > 0) ? _c('span', {
      staticClass: "game-has-done"
    }, [_vm._v("已完成")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "10px",
        "color": "#999",
        "margin-right": "5px"
      }
    }, [_vm._v("难度")]), _vm._v(" "), _c('level', {
      attrs: {
        "level": item.level
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "add-style",
    on: {
      "click": _vm.addModal
    }
  })], 2)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('mu-raised-button', {
    staticClass: "train-btn",
    staticStyle: {
      "margin-right": "20px",
      "width": "130px",
      "background-color": "#999",
      "color": "#fff"
    },
    attrs: {
      "label": "返回档案列表"
    },
    on: {
      "click": function($event) {
        _vm.confirmTrain(1)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "train-btn",
    attrs: {
      "label": "结束训练",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmTrain(2)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "timer-show"
  }, [(_vm.showTicker) ? _c('Ticker', {
    ref: "Ticker",
    attrs: {
      "caseId": _vm.caseId,
      "time": _vm.timeLeft,
      "tmID": _vm.tmID
    },
    on: {
      "timeOver": _vm.timeOver,
      "showClick": _vm.showClick
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "conf-dialog"
  }, [_c('mu-dialog', {
    attrs: {
      "dialogClass": "diaClass",
      "bodyClass": "bodyClass",
      "titleClass": "title",
      "open": _vm.showConf,
      "title": "训练设置"
    }
  }, [_c('selectLevel', {
    attrs: {
      "defaultTime": _vm.defaultTime,
      "showHardBar": _vm.showHardBar
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "position": "absolute",
      "right": "100px",
      "border-radius": "30px",
      "width": "120px",
      "height": "40px"
    },
    attrs: {
      "slot": "actions",
      "disabled": !_vm.startTrain,
      "primary": "",
      "label": "开始训练"
    },
    on: {
      "click": _vm.toTrain
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "position": "absolute",
      "left": "100px",
      "border-radius": "30px",
      "width": "120px",
      "height": "40px",
      "color": "#fff",
      "background-color": "#999"
    },
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  })], 1)], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.showOverTrain
    }
  }, [(_vm.overFlag == 1) ? _c('span', [_vm._v("训练尚未结束，确定要离开吗？确认离开将暂停倒计时。")]) : _c('span', [_vm._v("确定结束训练吗？")]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": function($event) {
        _vm.overTrain(0)
      }
    },
    slot: "actions"
  }), _vm._v(" "), (_vm.overFlag == 1) ? _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "离开"
    },
    on: {
      "click": function($event) {
        _vm.overTrain(_vm.overFlag)
      }
    },
    slot: "actions"
  }) : _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "结束"
    },
    on: {
      "click": function($event) {
        _vm.overTrain(_vm.overFlag)
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.showAddModal) ? _c('addMoreModal', {
    attrs: {
      "games": _vm.imgList
    },
    on: {
      "closeModal": _vm.cancelModal,
      "submitData": _vm.addTrain
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bfc7b09!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/times/trainTime.vue
// module id = 972
// module chunks = 2